import { cn } from '@/utils/cn';

interface PaginationButtonProps {
  onClick: () => void;
  isActive?: boolean;
  children: React.ReactNode;
}

export const PaginationButton = ({
  onClick,
  isActive,
  children,
}: PaginationButtonProps) => (
  <button
    className={cn(
      isActive ? 'bg-light-blue' : 'hover:bg-light-blue-o15',
      'relative z-10 inline-flex items-center px-4 py-2 font-semibold text-sm text-white focus:z-20 focus-visible:outline-2 focus-visible:outline-light-blue focus-visible:outline-offset-2'
    )}
    onClick={onClick}
    type="button"
  >
    {children}
  </button>
);
